import React from "react";
import {
  Box,
  Container,
  Typography,
  useMediaQuery,
  Link,
  Divider,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";

// Ajustando las rutas para FooterCliente (tres niveles arriba hasta Assets)
import logo from "../../../assets/logos-footer/clinifica_blanco.png"; // MODIFICADO: Agregado un ../ adicional
import venture from "../../../assets/logos-footer/ventures.png"; // MODIFICADO: Agregado un ../ adicional
import corfo from "../../../assets/logos-footer/corfo.png"; // MODIFICADO: Agregado un ../ adicional
import logoTexto from "../../../assets/logos-footer/logo_texto.png"; // MODIFICADO: Agregado un ../ adicional
import ins from "../../../assets/logos-footer/insta.png"; // MODIFICADO: Agregado un ../ adicional
import lin from "../../../assets/logos-footer/lin.png"; // MODIFICADO: Agregado un ../ adicional
import logoUnab from "../../../assets/logos-footer/logo_unab.png"; // NUEVO: Logo UNAB desde Components src\Assets\Footer\logo_unab.png
  
const estiloComun = {
  fontFamily: "Quicksand-Regular", 
  fontSize: "14px",
  color: "white",
};

const estiloTitulo = {
  ...estiloComun,
  fontFamily: "Quicksand-Bold",
  fontSize: "16px",
  marginBottom: "5px",
  color: "white",
  marginTop: "20px",
};

export default function FooterCliente() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const DesktopFooter = () => (
    <>
    <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 0 }}>
      <Typography sx={{ ...estiloComun, fontSize: "14px", mt: 4 }}>
        somos apoyados por
      </Typography>
    </Box>
  
      {/* Segunda línea: Logos de patrocinadores a la derecha */}
      <Box sx={{ display: "flex", mb: 4 }}>
        <Box sx={{ display: "flex", gap: 5, alignItems: "center" }}>
            <img
              src="/startup.svg"
              alt="Startup Chile"
              style={{
                height: 20,
                marginTop: 15,
              }}
            />
            <img
              src={corfo}
              alt="Corfo"
              style={{
                height: 40,
              }}
            />
            <img
              src={venture}
              alt="Venture Stars"
              style={{
                height: 30,
                marginTop: 5,
              }}
            />
            <img
              src={logoUnab}
              alt="UNAB"
              style={{
                height: 35,
                filter: "brightness(0) invert(1)", // Convierte el logo a blanco
              }}
            />
        </Box>
      </Box>
  
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          mt: 2,
          gap: 4
        }}
      >
        <Box>
          <Typography sx={estiloTitulo}>
            ¿Tienes dudas o necesitas ayuda?
          </Typography>
          <Typography sx={{ fontFamily: "Quicksand-Light", fontSize: "14px" }}>
            <Link href="tel:56920809101" underline="none" color="inherit">
              Llámanos por teléfono
            </Link>
            <br />
            <Link
              href="https://api.whatsapp.com/send/?phone=%2B56920809101&text=Hola,%20amigos%20de%20Clinifica.%20Tengo%20una%20duda,%20%C2%BFpodr%C3%ADan%20ayudarme?&type=phone_number&app_absent=0"
              underline="none"
              color="inherit"
            >
              Escríbenos al WhatsApp
              <br />
              +56 9 2080 9101
            </Link>
          </Typography>
        </Box>
  
        <Box>
          <Typography sx={estiloTitulo}>Legal</Typography>
          <Box>
            <Link
              href="https://clinifica.com/terminosycondiciones"
              color="inherit"
              sx={{ ...estiloComun, display: "block", textDecoration: "none" }}
            >
              Términos y condiciones
            </Link>
            <Link
              href="https://clinifica.com/politicadeprivacidad"
              color="inherit"
              sx={{ ...estiloComun, display: "block", textDecoration: "none" }}
            >
              Políticas de privacidad
            </Link>
          </Box>
        </Box>
  
        <Box>
          <Typography sx={estiloTitulo}>Recursos</Typography>
          <Box>
            <Link
              href="/"
              color="inherit"
              sx={{
                ...estiloComun,
                display: "block",
                textDecoration: "none",
              }}
            >
              Para pacientes
            </Link>
            <Link
              href="/pro"
              color="inherit"
              sx={{
                ...estiloComun,
                display: "block",
                textDecoration: "none",
              }}
            >
              Para profesionales
            </Link>
          </Box>
        </Box>
      </Box>
  
      <Divider sx={{ bgcolor: "white", my: 1 }} />
  
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <Typography
          sx={{
            fontFamily: "Quicksand-Bold",
            fontSize: "16px",
            color: "white",
            display: "flex",
            alignItems: "center",
          }}
        >
          Clinifica 2026
          <Link
            href="https://www.instagram.com/clinifica_cl"
            underline="none"
            color="inherit"
          >
            <img
              src={ins}
              alt="instagram"
              style={{
                width: "60px",
                height: "60px",
              }}
            />
          </Link>
          <Link
            href="https://www.linkedin.com/company/clinifica-pro/"
            underline="none"
            color="inherit"
          >
            <img
              src={lin}
              alt="linkedin"
              style={{
                width: "60px",
                height: "60px",
              }}
            />
          </Link>
        </Typography>
      </Box>
    </>
  );

  const MobileFooter = () => (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
        }}
      >
        <Box>
          <img src={logo} alt="Clinifica" style={{ height: 35 }} />
        </Box>
      </Box>
  
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          mb: 3,
        }}
      >
        <Box sx={{ mb: 3 }}>
          <Typography
            sx={{ fontFamily: "Quicksand-Bold", fontSize: "16px", mb: 1 }}
          >
            ¿Tienes dudas o necesitas ayuda?
          </Typography>
          <Typography sx={{ fontFamily: "Quicksand-Light", fontSize: "14px" }}>
            <Link href="tel:56920809101" underline="none" color="inherit">
              Llámanos por teléfono
            </Link>
            <br />
            <Link
              href="https://api.whatsapp.com/send/?phone=%2B56920809101&text=Hola,%20amigos%20de%20Clinifica.%20Tengo%20una%20duda,%20%C2%BFpodr%C3%ADan%20ayudarme?&type=phone_number&app_absent=0"
              underline="none"
              color="inherit"
            >
              Escríbenos al WhatsApp
              <br />
              +56 9 2080 9101
            </Link>
          </Typography>
        </Box>
        
        <Typography sx={{ ...estiloComun, fontSize: "14px", mb: 1 }}>
          Somos apoyados por
        </Typography>
        
        <Box 
          sx={{ 
            display: "flex", 
            gap: 2, 
            alignItems: "center",
            justifyContent: "flex-start",
            flexWrap: "wrap",
            maxWidth: "100%"
          }}
        >
          <img
            src="/startup.svg"
            alt="startup"
            style={{
              height: 16,
              maxWidth: "33%",
              objectFit: "contain", 
              marginTop: 4
            }}
          />
          <img 
            src={corfo} 
            alt="Corfo" 
            style={{ 
              height: 16,
              maxWidth: "33%", 
              objectFit: "contain"
            }} 
          />
          <img 
            src={venture} 
            alt="Venture" 
            style={{ 
              height: 16,
              maxWidth: "33%",
              objectFit: "contain",
              marginTop: 1
            }} 
          />
        </Box>
        
        {/* Nueva fila para UNAB en mobile */}
        <Box 
          sx={{ 
            display: "flex",
            justifyContent: "flex-start",
            mt: 2
          }}
        >
          <img 
            src={logoUnab} 
            alt="UNAB" 
            style={{ 
              height: 16,
              objectFit: "contain",
              filter: "brightness(0) invert(1)" // Convierte el logo a blanco
            }} 
          />
        </Box>
      </Box>
      
      <Box sx={{ mb: 3 }}>
        <Typography sx={estiloTitulo}>Recursos</Typography>
        <Box>
          <Link
            href="/"
            color="inherit"
            sx={{ ...estiloComun, display: "block", textDecoration: "none" }}
          >
            Para pacientes
          </Link>
          <Link
            href="/pro"
            color="inherit"
            sx={{ ...estiloComun, display: "block", textDecoration: "none" }}
          >
            Para profesionales
          </Link>
        </Box>
      </Box>

      <Box sx={{ mb: 3 }}>
        <Typography sx={estiloTitulo}>Legal</Typography>
        <Box>
          <Link
            href="https://clinifica.com/terminosycondiciones"
            color="inherit"
            sx={{ ...estiloComun, display: "block", textDecoration: "none" }}
          >
            Términos y condiciones
          </Link>
          <Link
            href="https://clinifica.com/politicadeprivacidad"
            color="inherit"
            sx={{ ...estiloComun, display: "block", textDecoration: "none" }}
          >
            Políticas de privacidad
          </Link>
        </Box>
      </Box>
  
      <Divider sx={{ bgcolor: "white", my: 2 }} />
  
      <Box 
        sx={{ 
          display: "flex", 
          alignItems: "center", 
          justifyContent: "space-between" 
        }}
      >
        <Typography
          sx={{
            fontFamily: "Quicksand-Bold",
            fontSize: "16px",
            color: "white",
            display: "flex",
            alignItems: "center",
          }}
        >
          Clinifica 2026
        
          <Link
            href="https://www.instagram.com/clinifica_cl"
            underline="none"
            color="inherit"
          >
            <img
              src={ins}
              alt="instagram"
              style={{
                width: "40px",
                height: "40px",
              }}
            />
          </Link>
          <Link
            href="https://www.linkedin.com/company/clinifica-pro/"
            underline="none"
            color="inherit"
          >
            <img
              src={lin}
              alt="linkedin"
              style={{
                width: "40px",
                height: "40px",
              }}
            />
          </Link>
        </Typography>
      </Box>
    </>
  );

  return (
    <Box
      sx={{
        px: { xs: 2, md: 3 }, // Padding horizontal para espacio blanco lateral
        pb: { xs: 2, md: 3 }, // Padding inferior para espacio blanco abajo
      }}
    >
      <Box
        sx={{
          backgroundColor: "#4669E8",
          borderRadius: "8px", // 4 bordes redondeados
          pt: isMobile ? 2.5 : 1.5,
          pb: isMobile ? 2.5 : 1.5,
          color: "white",
        }}
      >
        <Container maxWidth="lg">
          {isMobile ? <MobileFooter /> : <DesktopFooter />}
        </Container>
      </Box>
    </Box>
  );
}
